import React from 'react';
import { Button } from 'react-bootstrap';

function Socials() {
    return (
        <div className="socials">
            <Button variant="primary" href="https://www.etsy.com/uk/shop/LittleBCraftsStore">Etsy</Button>
            <Button variant="primary" href="https://www.facebook.com/profile.php?id=100077209519258">Facebook</Button>
            <Button variant="primary" href="https://www.instagram.com/littleb_crafts/">Instagram</Button>
            <Button variant="primary" href="mailto:nicole@littlebcrafts.co.uk" target="_blank">Email</Button>
        </div>
    );
}

export default Socials;